import React from 'react';
import cn from 'classnames';
import SectionTitle from '../../Shared/Tailwind/SectionTitle';

type SampleImageItem = {
  title: string;
  src: string;
  alt: string;
  width?: string;
  sectionClassName?: string;
  imageClassName?: string;
  imageStyle?: React.CSSProperties;
  imageWrapperClassName?: string;
  loading?: 'eager' | 'lazy';
};

type SampleImagePageProps = {
  title?: string;
  cardClassName: string;
  titleClassName: string;
  sectionClassName: string;
  sectionTitleClassName: string;
  items: SampleImageItem[];
};

const SampleImagePage = ({ title, cardClassName, titleClassName, sectionClassName, sectionTitleClassName, items }: SampleImagePageProps) => {
  return (
    <div className={cardClassName}>
      {title && <SectionTitle className={titleClassName}>{title}</SectionTitle>}
      {items.map((item) => {
        const image = (
          <img
            src={item.src}
            alt={item.alt}
            width={item.width}
            className={item.imageClassName}
            style={item.imageStyle}
            loading={item.loading ?? 'lazy'}
            decoding='async'
          />
        );

        return (
          <div key={item.title} className={cn(sectionClassName, item.sectionClassName)}>
            <SectionTitle className={sectionTitleClassName}>{item.title}</SectionTitle>
            {item.imageWrapperClassName ? <div className={item.imageWrapperClassName}>{image}</div> : image}
          </div>
        );
      })}
    </div>
  );
};

export default SampleImagePage;
